export const EMISSIONS_NOTIFICATION_TYPE = {
  ON_TARGET: "ON_TARGET",
  REACH_TARGET: "REACH_TARGET",
  BELOW_TARGET: "BELOW_TARGET",
  SET_TARGET: "SET_TARGET",
  REVISE_TARGET: "REVISE_TARGET",
  UPDATE_FUEL_GRADE: "UPDATE_FUEL_GRADE",
  SET_FUEL_GRADE: "SET_FUEL_GRADE",
};
export const LOCAL_STORAGE = {
  USER_DETAIL: "userDetail",
  USER_INFO: "userInfo",
  INTEGRATION_STATUS: "INTEGRATION_STATUS",
  ROUTE: "ROUTE",
  CURRENT_USER: "currentUser",
  AUTO_CLOSE: "AUTO_CLOSE",
  IS_IMPERSONATING: "isImpersonating",
  IS_ME_API_RUNNING: "IS_ME_API_RUNNING",
};

export const STEP_STATUS = {
  ACTIVE: "active",
  COMPLETED: "completed",
  PENDING: "pending",
  FAILED: "failed",
};

export const ONBOARDING_TSP_METHODS = {
  BASIC: "Basic key",
  BEARER: "Bearer Token",
  O_AUTH: "OAuth",
  API_KEY: "API Key",
  U_P: "Username & password",
};

export const LANGUAGES = {
  EN: "en",
  FR: "fr",
};
export const LOCALE = {
  IN: "en-IN",
  US: "en-US",
};
export const DEFAULT_LOCALE_CONST = {
  LANG: "defaultLanguage",
  CURRENCY: "defaultCurrency",
  LOCALE: "defaultLocale",
};
export const ROUNDING_MODE = {
  ROUND: Math.round,
  FLOOR: Math.floor,
  CEIL: Math.ceil,
};

export const INPUT_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const INPUT_NUMBER_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const AUTOCOMPLETE_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const OTP_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const LABEL_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  RIGHT: "RIGHT",
};

export const DROPDOWN_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  TERTIARY: "TERTIARY",
  QUATERNARY: "QUATERNARY",
};

export const INPUT_ERROR_TYPE = {
  BORDER: "BORDER",
  DEFAULT: "DEFAULT",
};

export const LIMIT_TYPE = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
};

export const CHECKBOX_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const TOAST_VARIANT = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  TERTIARY: "TERTIARY",
  QUATERNARY: "QUATERNARY",
  PRIMARY_LIGHT: "PRIMARYLIGHT",
  SECONDARY_LIGHT: "SECONDARYLIGHT",
  TERTIARY_LIGHT: "TERTIARYLIGHT",
  QUATERNARY_LIGHT: "QUATERNARYLIGHT",
};

export const BUTTON_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const COLOR_STYLE_TYPE = {
  RED: "RED",
  GRAY: "GRAY",
  PLUM: "PLUM",
};

export const LOADER_POSITION = {
  RIGHT: "right",
  LEFT: "left",
};
export const MIME_TYPE = {
  JSON: "application/json",
  PLAIN: "text/javascript",
};

export const IS_ROUTE_GUARD = {
  Y: "Y",
  N: "N",
};

// ENVIRONMENT VARIABLE CONSTANTS
export const ENV_VAR = {
  VITE_BASE_API_URL: "VITE_BASE_API_URL",
  VITE_ENABLE_PWA_MODE: "VITE_ENABLE_PWA_MODE",
  VITE_LOCAL_DB_NAME: "VITE_LOCAL_DB_NAME",
  VITE_IS_ACL_ENABLED: "VITE_IS_ACL_ENABLED",
  VITE_IS_ROUTE_GUARD: "VITE_IS_ROUTE_GUARD",
  VITE_SHOW_LOGS: "VITE_SHOW_LOGS",
};

export const USER_PROFILE_STATE = {
  EMAIL_VERIFICATION_PENDING: "EMAIL_VERIFICATION_PENDING",
  EMAIL_VERIFIED: "EMAIL_VERIFIED",
  CONNECT_DATA: "CONNECT_DATA",
  COMPLETED: "COMPLETED",
  APPROVAL_PENDING: "APPROVAL_PENDING",
};

export const DESIGNATION = [
  { label: "CXO", value: "CXO" },
  { label: "Channel Manager", value: "Channel Manager" },
  { label: "Analyst", value: "Analyst" },
  { label: "Agency", value: "Agency" },
];

export const LINK_EXPIRY_TYPE = {
  EMAIL: "EMAIL",
  RESET: "RESET",
};

export const USER_PROFILE_STAGE = {
  PROFILE_SETUP: "PROFILE_SETUP",
  TSP_INTEGRATION: "TSP_INTEGRATION",
  VEHICLE_PROCESSING: "VEHICLE_PROCESSING",
  MANUAL_UPLOAD_CONFIRMATION: "MANUAL_UPLOAD_CONFIRMATION",
  MANUAL_UPLOAD: "MANUAL_UPLOAD",
  DATA_ENHANCEMENT: "DATA_ENHANCEMENT",
  FUEL_GRADE_PREFERENCES: "FUEL_GRADE_PREFERENCES",
  ON_BOARDING: "ONBOARDING",
  DATA_PROCESSING: "DATA_PROCESSING",
  READY: "READY",
  // PROFILE_PENDING: "PROFILE_PENDING",
  // TSP_PENDING: "TSP_PENDING",
  // PROFILE_COMPLETED: "PROFILE_COMPLETED",
  // CARBON_EMISSION_COMPLETED: "CARBON_EMISSION_COMPLETED",
};

export const USER_TYPE = {
  SUPER_USER: "SUPER_USER",
  SUB_USER: "SUB_USER",
};

export const USER_STATUS = {
  ALL: "ALL",
  INVITED: "INVITED",
  ACTIVE: "ACTIVE",
  PENDING: "PENDING",
  INACTIVE: "INACTIVE",
};

export const USER_STATUS_LIST = [
  { label: "All", value: USER_STATUS.ALL },
  { label: "Active", value: USER_STATUS.ACTIVE },
  { label: "Pending", value: USER_STATUS.PENDING },
  { label: "Inactive", value: USER_STATUS.INACTIVE },
  { label: "Invited", value: USER_STATUS.INVITED },
  // { label: "Inactive", value: USER_STATUS.INACTIVE },
];
interface QuarterOption {
  label: string;
  value: string;
  note?: string; // The '?' indicates that 'note' is optional
}

export const PERIODIC_YEAR: QuarterOption[] = [
  { label: "Q1 (Jan - Mar)", value: "1:3" },
  { label: "Q2 (Apr - Jun)", value: "4:6" },
  { label: "Q3 (Jul - Sep)", value: "7:9" },
  { label: "Q4 (Oct - Dec)", value: "10:12" },
  { label: "Annual", value: "Annual" },
];

export const QuartersOfMonthsWithAnnual: QuarterOption[] = [
  { label: "Q1 (Jan - Mar)", value: "Q1 (Jan - Mar)" },
  { label: "Q2 (Apr - Jun)", value: "Q2 (Apr - Jun)" },
  { label: "Q3 (Jul - Sep)", value: "Q3 (Jul - Sep)" },
  { label: "Q4 (Oct - Dec)", value: "Q4 (Oct - Dec)" },
  { label: "Annual", value: "Annual" },
];

export const VEHICLE_CLASSES = [
  { label: "1A", value: "1A" },
  { label: "1B", value: "1B" },
  { label: "1C", value: "1C" },
  { label: "1D", value: "1D" },
  { label: "2E", value: "2E" },
  { label: "2F", value: "2F" },
  { label: "2G", value: "2G" },
  { label: "2H", value: "2H" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
];

export const PAGE_MODE = {
  CREATE: "CREATE",
  VIEW: "VIEW",
  EDIT: "EDIT",
  REVIEW: "REVIEW",
  REVIEW_CREATE: "REVIEW_CREATE",
};

export const EDITABLE_TABLE_ACTIONS = {
  IS_ADDED: "isAdded",
  IS_UPDATED: "isUpdated",
  IS_INACTIVE: "isInactive",
};

export const CURRENCY_SYMBOL = {
  USD: "$",
};

export const OFFSET_BY_OPTIONS = [
  { label: "Price", value: "totalPrice" },
  { label: "Quantity", value: "quantity" },
];

export const OFFSET_BY_MODE = {
  PRICE: "totalPrice",
  QUANTITY: "quantity",
};

export const SHORT_MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const OFFSET_ORDER_TYPE = {
  EXTERNAL: "External",
};

export const OFFSET_ORDER_STATUS = [
  { label: "All", value: "ALL" },
  { label: "Placed", value: "PLACED" },
  { label: "Processing", value: "PROCESSING" },
  { label: "Completed", value: "COMPLETED" },
  { label: "Cancelled", value: "CANCELLED" },
];

// Download options for Sustainabilty Marketing Internal Dashboard - Analytics Page

export const DOWNLOAD_ANALYTICS_OPTIONS = [
  {
    label: "Last 30 days",
    value: "30",
  },
  {
    label: "Last 60 days",
    value: "60",
  },
  {
    label: "Last 90 days",
    value: "90",
  },
];

// Download options for Marketing dashboard

export const DOWNLOAD_OPTIONS = [
  {
    label: "2023",
    value: "2023",
  },
  {
    label: "2022",
    value: "2022",
  },
  {
    label: "2021",
    value: "2021",
  },
  {
    label: "2020",
    value: "2020",
  },
];

export const OFFSET_ORDER_YEAR_LIST = [{ label: "All year", value: "ALL_YEAR" }];

export const DEFAULT_SELECTION = {
  ALL: "ALL",
  ALL_YEAR: "ALL_YEAR",
};
//Options for fuel dashboard
export const FUEL_OPTIONS = [
  { label: "Gasoline", value: "gasoline" },
  { label: "E85", value: "e85" },
  { label: "LPG", value: "lpg" },
  { label: "Diesel", value: "diesel" },
  { label: "B20", value: "b20" },
  { label: "B99", value: "b99B100" },
  { label: "CNG", value: "cng" },
  { label: "LNG", value: "lng" },
];

// Options for states mapping

export const STATE_OPTIONS = [
  { label: "Alabama", value: "Alabama" },
  { label: "Alaska", value: "Alaska" },
  { label: "Arizona", value: "Arizona" },
  { label: "Arkansas", value: "Arkansas" },
  { label: "California", value: "California" },
  { label: "Colorado", value: "Colorado" },
  { label: "Connecticut", value: "Connecticut" },
  { label: "Delaware", value: "Delaware" },
  { label: "Florida", value: "Florida" },
  { label: "Georgia", value: "Georgia" },
  { label: "Hawaii", value: "Hawaii" },
  { label: "Idaho", value: "Idaho" },
  { label: "Illinois", value: "Illinois" },
  { label: "Indiana", value: "Indiana" },
  { label: "Iowa", value: "Iowa" },
  { label: "Kansas", value: "Kansas" },
  { label: "Kentucky", value: "Kentucky" },
  { label: "Louisiana", value: "Louisiana" },
  { label: "Maine", value: "Maine" },
  { label: "Maryland", value: "Maryland" },
  { label: "Massachusetts", value: "Massachusetts" },
  { label: "Michigan", value: "Michigan" },
  { label: "Minnesota", value: "Minnesota" },
  { label: "Mississippi", value: "Mississippi" },
  { label: "Missouri", value: "Missouri" },
  { label: "Montana", value: "Montana" },
  { label: "Nebraska", value: "Nebraska" },
  { label: "Nevada", value: "Nevada" },
  { label: "New Hampshire", value: "New Hampshire" },
  { label: "New Jersey", value: "New Jersey" },
  { label: "New Mexico", value: "New Mexico" },
  { label: "New York", value: "New York" },
  { label: "North Carolina", value: "North Carolina" },
  { label: "North Dakota", value: "North Dakota" },
  { label: "Ohio", value: "Ohio" },
  { label: "Oklahoma", value: "Oklahoma" },
  { label: "Oregon", value: "Oregon" },
  { label: "Pennsylvania", value: "Pennsylvania" },
  { label: "Rhode Island", value: "Rhode Island" },
  { label: "South Carolina", value: "South Carolina" },
  { label: "South Dakota", value: "South Dakota" },
  { label: "Tennessee", value: "Tennessee" },
  { label: "Texas", value: "Texas" },
  { label: "Utah", value: "Utah" },
  { label: "Vermont", value: "Vermont" },
  { label: "Virginia", value: "Virginia" },
  { label: "Washington", value: "Washington" },
  { label: "West Virginia", value: "West Virginia" },
  { label: "Wisconsin", value: "Wisconsin" },
  { label: "Wyoming", value: "Wyoming" },
];


export const TABLE_SORTING_LIST = [
  { label: "Newest to Oldest", value: "DESC" },
  { label: "Oldest to Newest", value: "ASC" },
];

export enum ORDER_STATUS {
  PLACED = "PLACED",
  COMPLETED = "COMPLETED",
  PROCESSING = "PROCESSING",
}

export enum PAYMENT_STATUS {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  INITIATED = "INITIATED",
}

// Customer type


export const CUSTOMER_TYPE_OPTIONS = [
  { label: "Internal", value: "INTERNAL" },
  { label: "Demo", value: "DEMO" },
  { label: "Trial", value: "TRIAL" },
  { label: "Paid", value: "PAID" },
  { label: "Support", value: "SUPPORT" },
];


